import React from 'react';
import ContactForm from '../ContactFrom/ContactForm'


const ContactSection = () => {

    return (
      <section className="wpo-contact-pg-section">
        <div className="container">
          <div className="row">
            <div className="col col-lg-10 offset-lg-1">
              <div className="wpo-contact-title">
                <h2>Formulario de Contacto</h2>
                <p>
                  Llena el formulario a continuación para contactarnos. Nos pondremos en contacto contigo lo antes posible.
                </p>
              </div>
              <div className="wpo-contact-form-area">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
        <section className="wpo-contact-map-section">
          <div className="wpo-contact-map">
            <iframe
              title="comtact-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3922.874890956013!2d-66.8992556!3d10.510518999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c2a59529815d00b%3A0x1b87d5d34c407476!2sWMCLINIC!5e0!3m2!1ses-419!2sco!4v1750863066711!5m2!1ses-419!2sco"
            ></iframe>
          </div>
        </section>
      </section>
    );

}

export default ContactSection;
